module.exports = __webpack_public_path__ + "img/WildPinataCC_EGM.d39f4c95.jpg";